import React, { useState } from 'react';

import styled from '@emotion/styled';

interface ITableSearchFormField {
  setSearchQuery: (...args: any[]) => void;
}

let debounceTimer: any;

const TableSearchFormField: React.FC<ITableSearchFormField> = ({
  setSearchQuery,
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchTermChange = (e: any) => {
    const value = e.target.value;
    clearTimeout(debounceTimer);
    setSearchTerm(value);
    debounceTimer = setTimeout(() => {
      setSearchQuery(value);
    }, 500);
  };

  return (
    <Form>
      <TableSearchInputField
        placeholder={'Search Table'}
        onChange={handleSearchTermChange}
        value={searchTerm}
      />
    </Form>
  );
};

export default TableSearchFormField;

const Form = styled.form``;

const TableSearchInputField = styled.input`
  border: 1px solid #c2bebc;
  /* border: 2px solid green; */
  border-radius: 0.5rem;
  padding: 1.25rem 1rem;
  text-align: left;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.secondaryText};
  font-size: 1rem;
  height: 48px;
  cursor: text;
  width: 19.25rem;
  /* appearance: none; */

  &:focus {
    outline: none;
    border-color: #f46f3b;
    /* background-color: ${({ theme }) =>
      theme.palette.inputFieldFocusColor}; */
  }
  &:hover {
    cursor: text;
  }

  &::placeholder {
    color: #867c79;
    opacity: 1;
    font-weight: 400;
  }
`;
